import { latLngBounds } from '@shared/googleMaps';

class Zoom {
  static fitToMapCoordinates = (coordinateString: string | null, map: google.maps.Map) => {
    if (!coordinateString) return;
    const coordinates = coordinateString.split(',');
    const southWest = {
      lat: Number(coordinates[0]),
      lng: Number(coordinates[1]),
    };
    const northEast = {
      lat: Number(coordinates[2]),
      lng: Number(coordinates[3]),
    };
    const bounds = latLngBounds(southWest, northEast);
    map.fitBounds(bounds);
  };
}

export default Zoom;
